var map = {
	"./versao2023": [
		876,
		876
	],
	"./versao2023.jsx": [
		876,
		876
	],
	"./versao2024": [
		7111,
		111
	],
	"./versao2024.jsx": [
		7111,
		111
	],
	"./versao2025": [
		6946,
		946
	],
	"./versao2025.jsx": [
		6946,
		946
	],
	"./versao2026": [
		5589,
		589
	],
	"./versao2026.jsx": [
		5589,
		589
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8953;
module.exports = webpackAsyncContext;